import PropTypes from 'prop-types'
import { mergeOverrides } from 'baseui'
import { SDCheckboxOverrides, SDCheckboxPulseOverrides } from './styled-components'
import { Checkbox, LABEL_PLACEMENT, STYLE_TYPE } from 'baseui/checkbox'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

// `kind='switch'` is for an option that unfolds more fields: PULSE draws it as a switch, today's look keeps the box.
const SDCheckbox = ({ label, overrides, checked, onChange, error, labelPlacement, kind = 'checkbox', ...rest }) => {
  const isPulse = usePulseScope()
  const isSwitch = isPulse && kind === 'switch'
  const baseOverrides = isPulse ? SDCheckboxPulseOverrides(error || false) : SDCheckboxOverrides(error || false)
  const newOverrides = mergeOverrides(baseOverrides, overrides)

  return (
    <Checkbox
      {...rest}
      checked={checked}
      overrides={newOverrides}
      onChange={e => onChange(e.target.checked)}
      checkmarkType={isSwitch ? STYLE_TYPE.toggle : rest.checkmarkType}
      labelPlacement={isSwitch ? LABEL_PLACEMENT.right : labelPlacement}
    >
      {label}
    </Checkbox>
  )
}

SDCheckbox.propTypes = {
  label: PropTypes.node,
  overrides: PropTypes.object,
  checked: PropTypes.any,
  onChange: PropTypes.func,
  labelPlacement: PropTypes.any,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  kind: PropTypes.oneOf(['checkbox', 'switch']),
}

export default SDCheckbox
